import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import React, { useEffect } from "react";
import { useAPIEditService } from "../api/api-edit-service";
import {
  genElNumber,
  genElText,
} from "@components/utils/EditorDialogElementGenerator";
import { ProgressSpinner } from "primereact/progressspinner";

const ServiceEdit = (props) => {
  const { visible, onHide, editorData, onConfirmed } = props;

  const {
    loading,
    data,
    setData,
    fetchDataOrCreateNew,
    error,
    handleOnConfirm,
  } = useAPIEditService({ onConfirmed });

  // use effect section

  useEffect(() => {
    if (visible) {
      fetchDataOrCreateNew({ id: editorData.id, extraData: editorData });
    }
  }, [visible]);

  // handle ui event section

  // genereate editor element section

  const elNama = genElText({
    field: "nama",
    name: "Nama",
    value: data.nama ?? "",
    data,
    setData,
    error,
  });

  const elDefaultKM = genElNumber({
    field: "default_km",
    name: "KM",
    value: data.default_km ?? 0,
    data,
    setData,
    error,
  });

  const elDefaultKMWarning = genElNumber({
    field: "default_km_warning",
    name: "KM Warning",
    value: data.default_km_warning ?? 0,
    data,
    setData,
    error,
  });

  const dialogFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        outlined
        onClick={props.onHide}
      />
      <Button
        label="Save"
        icon="pi pi-check"
        onClick={(e) => {
          handleOnConfirm();
        }}
      />
    </React.Fragment>
  );

  return (
    <Dialog
      visible={visible}
      style={{ width: "25rem" }}
      breakpoints={{ "960px": "75vw", "641px": "90vw" }}
      header={data.id && data.id > 0 ? "Edit Service" : "Tambah Service"}
      modal
      className={`p-fluid`}
      footer={dialogFooter}
      onHide={onHide}
      contentClassName="py-4 !pb-6"
      pt={{ footer: { className: "py-4" }, header: { className: "py-4" } }}
    >
      <div className="col-start-center relative h-100 gap-3">
        {elNama}
        {elDefaultKM}
        {elDefaultKMWarning}
        {loading && (
          <div
            className={`col-center-center w-100  gap-2 absolute z-100 h-100 bg-black/20 rounded `}
          >
            <ProgressSpinner />
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default ServiceEdit;
